/**
 * @generated SignedSource<<f275d4741bd883a97b6463c24be37751>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RegisterUserInput = {
  checkoutId?: string | null;
  email?: string | null;
  verificationCode: string;
};
export type JoinCommunityFormVerifyEmailSectionMutation$variables = {
  input: RegisterUserInput;
};
export type JoinCommunityFormVerifyEmailSectionMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly firstName: string | null;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
  };
};
export type JoinCommunityFormVerifyEmailSectionMutation = {
  response: JoinCommunityFormVerifyEmailSectionMutation$data;
  variables: JoinCommunityFormVerifyEmailSectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegisterUserResponse",
    "kind": "LinkedField",
    "name": "registerUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JoinCommunityFormVerifyEmailSectionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JoinCommunityFormVerifyEmailSectionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7813502c72221dead681a01ba72c3ab8",
    "id": null,
    "metadata": {},
    "name": "JoinCommunityFormVerifyEmailSectionMutation",
    "operationKind": "mutation",
    "text": "mutation JoinCommunityFormVerifyEmailSectionMutation(\n  $input: RegisterUserInput!\n) {\n  response: registerUser(input: $input) {\n    node {\n      id\n      firstName\n      lastName\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bdee071beec96b509b4d71cf98195cc";

export default node;
